<script setup lang="ts">
import { computed } from 'vue';
import type { Props } from './types';
import Core from '@/core/core/core';
import Button from '@/components/forms/button/button.vue';
import Popup from '@/components/popup/popup/popup.vue';
import ListItem from '@/components/popup/popup/listItem.vue';
import Menu from '@/components/formsExt/menu/menu.vue';
import { useI18n } from '@/core/plugins/i18n';

const props = withDefaults(defineProps<Props>(), {
	showSelectAllItem: true,
});
const model = defineModel<Props['modelValue']>();

const selectAllItem = computed(() => {
	if (props.showSelectAllItem) {
		return {
			icon: '',
			title: useI18n().Common.Select_all,
			value: 'all',
			content: '',
		};
	}
});
</script>

<template>
	<div class="top-selectorCompetitors">
		<Popup v-if="Core.state.isMobile">
			<template #opener>
				<Button
					class="top-selectorCompetitors_opener"
					color="theme"
					icon=""
					icon2=""
				>
					{{ items.find((item) => item.value === model?.[0])?.content }}
				</Button>
			</template>

			<template #contentList>
				<ListItem
					v-for="(item) in items"
					:class="{
						'top-active': model?.includes(item.value)
					}"
					:data-top-icon="item.icon"
					:title="item.title"
					@click="() => model = [item.value]"
				>
					<span class="top-ellipsis1">
						{{ item.content }}
					</span>
				</ListItem>
			</template>
		</Popup>

		<Menu
			v-else
			v-model="model"
			:items="items"
			:isMultiple="true"
			styling="bar"
			:canBeEmptyMultiple="false"
			:selectAllItem="selectAllItem"
		/>
	</div>
</template>

<style>
.top-selectorCompetitors_opener.top-button {
	width: 100%;
}
</style>
